import ApiService from '@/services/core/api.service'

const HistoryService = {
  async get (query) {
    return ApiService.get(`shared/history?${query}`)
  }
}

export default HistoryService
